import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UserReportMetric} from "../../../models/report/UserReport";
import {BaseComponent} from "../../BaseComponent";
import {AggregateFunctionTypeEnum} from "../../../enums/dashboard/ChartsEnum";
import {ValueChangedEvent} from "devextreme/ui/select_box";

@Component({
  selector: 'app-report-metrics-table',
  templateUrl: './user-report-metrics-table.component.html',
  styleUrls: ['./user-report-metrics-table.component.css']
})
export class UserReportMetricsTableComponent extends BaseComponent {

  @Input() metrics: UserReportMetric[] = [];
  @Input() disabled: boolean = false;
  @Output() dataChanged = new EventEmitter<void>();

  protected readonly functionTypeValues = Object.values(AggregateFunctionTypeEnum);

  translateFunctionType = (functionType: string): string => {
    return this.translate.instant('CHART_CREATION.CHART_TYPES.' + functionType);
  };

  reorderItem = ($event: any): void => {
    if ($event.toIndex < this.metrics.length) {
      this.metrics.splice($event.toIndex, 0, this.metrics.splice($event.fromIndex, 1)[0]);
      this.dataChanged.emit();
    }
  };

  setSelectorValue(event: ValueChangedEvent, cellInfo: any): void {
    cellInfo.setValue(event.value);
    this.dataChanged.emit();
  }
}
